import FormPreview from '@/modules/core/components/common/renderers/FormPreview/FormPreview'

export default FormPreview
